/**
 * Para yardımcıları. Sunucu kuruşu BIGINT tutar, API'de kanonik ondalık metin ("1250.50") taşır.
 * İstemci asla float aritmetiği yapmaz; ekranda Türkçe biçim "1.250,50 TL" (PDF §04).
 */

const CANON = /^-?\d{1,13}(?:\.\d{1,2})?$/;

/** "1250.50" → 125050n (bigint kuruş). */
export function apiToKurus(value: string): bigint {
  if (!CANON.test(value)) throw new Error(`Geçersiz tutar: ${value}`);
  const neg = value.startsWith('-');
  const [whole = '0', frac = ''] = value.replace('-', '').split('.');
  const k = BigInt(whole) * 100n + BigInt(frac.padEnd(2, '0'));
  return neg ? -k : k;
}

/** 125050n → "1250.50" */
export function kurusToApi(kurus: bigint): string {
  const neg = kurus < 0n;
  const k = neg ? -kurus : kurus;
  return `${neg ? '-' : ''}${k / 100n}.${(k % 100n).toString().padStart(2, '0')}`;
}

/** "1250.50" → "1.250,50 TL" */
export function formatTL(value: string | bigint, withCurrency = true): string {
  const k = typeof value === 'bigint' ? value : apiToKurus(value);
  const neg = k < 0n;
  const abs = neg ? -k : k;
  const whole = (abs / 100n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const s = `${neg ? '-' : ''}${whole},${(abs % 100n).toString().padStart(2, '0')}`;
  return withCurrency ? `${s} TL` : s;
}

/**
 * Kullanıcı girişi → kanonik API metni. "1.234,56", "1234,56", "1234.56", "12,5" kabul edilir.
 * Belirsiz girdi (ör. "1,234.56") null döner; form hata gösterir.
 */
export function parseUserAmount(input: string): string | null {
  const s = input.trim().replace(/\s|₺|TL/gi, '');
  if (!s) return null;
  let m = /^(\d{1,3}(?:\.\d{3})+|\d+)(?:,(\d{1,2}))?$/.exec(s);
  if (m) {
    const whole = (m[1] ?? '').replace(/\./g, '');
    const frac = (m[2] ?? '').padEnd(2, '0');
    return normalize(whole, frac);
  }
  m = /^(\d+)\.(\d{1,2})$/.exec(s);
  if (m) return normalize(m[1] ?? '0', (m[2] ?? '').padEnd(2, '0'));
  return null;
}

function normalize(whole: string, frac: string): string | null {
  const w = whole.replace(/^0+(?=\d)/, '');
  if (w.length > 13) return null;
  const k = BigInt(w) * 100n + BigInt(frac);
  if (k <= 0n) return null;
  return kurusToApi(k);
}

/** Kanonik metni form alanı için Türkçe girişe çevirir: "1250.50" → "1.250,50" */
export function apiToInput(value: string | null | undefined): string {
  return value ? formatTL(value, false) : '';
}
